import api from '@/services/apiClient';

const BASE_URL = process.env.VUE_APP_BASE_URL as string;
const PATH = `${BASE_URL}/api/v1/summary-calculated`;

export default {
  async getList(page: any) {
    return api.post(`${PATH}/list`, page).then((response: any) => response.data);
  },

  async generate(year: number, universityId: number | null = null) {
    const url = universityId ? `${PATH}/generate/${year}?universityId=${universityId}` : `${PATH}/generate/${year}`;
    return api.post(url).then((response: any) => response.data);
  },

  async download(uuid: string) {
    return api.get(`${PATH}/download/${uuid}`, { responseType: 'blob' });
  },

  async deleteById(uuid: string) {
    return api.delete(`${PATH}/${uuid}`).then((response: any) => response.data);
  }
};
